import { defineComponent as _defineComponent } from 'vue'
import UserAvatar from '@/components/UserAvatar.vue'
import ContactListItemTag from '@/components/Contact/ContactListItemTag.vue'
import {computed, withDefaults} from 'vue'
import {Contact} from "@/models/dto/ContactGroup";
import { useDisplay } from '@/composables/useDisplay'

export default /*#__PURE__*/_defineComponent({
  __name: 'ContactListItem',
  props: {
    id: null,
    isBookingContact: { type: Boolean },
    editable: { type: Boolean, default: false },
    contact: null,
    alignLeft: { type: Boolean, default: false },
    hideDelete: { type: Boolean, default: false }
  },
  emits: ["edit", "delete:contact"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'edit'): void
  (e: 'delete:contact'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { id: string, isBookingContact?: boolean, editable: boolean, contact: Contact, alignLeft: boolean, hideDelete: boolean };

const { xs } = useDisplay()
const fullscreen = computed(() => xs.value)






const tagText = computed<string>(() => {
  if (props.isBookingContact) {
    return 'Default Trip Contact'
  }
  if (props.contact.isTripContact) {
    return 'Trip Contact'
  }
  return ''
})

const tagTooltipText = computed(() => {
  if (props.isBookingContact) {
    return 'For any trip day communication, we\'ll contact this person first before contacting other Trip Contacts.'
  }
  if (props.contact.isTripContact) {
    return 'If we can\'t reach the booking contact on trip day, we\'ll contact this person as a backup. Best to choose someone on the bus.'
  }
  return ''
})


return { __sfc: true,xs, fullscreen, emit, props, tagText, tagTooltipText, UserAvatar, ContactListItemTag }
}

})